import { useEffect, useRef } from "react";

// Adds .in-view to elements with .reveal once they enter viewport.
// Sets html.js-reveal-ready first so reveal elements start at opacity 0 only when JS is alive.
// If the observer ever fails / doesn't fire, content remains visible by default.
export function useReveal() {
    const observed = useRef(false);
    useEffect(() => {
        if (observed.current) return;
        observed.current = true;

        if (!("IntersectionObserver" in window)) return;

        document.documentElement.classList.add("js-reveal-ready");

        const els = document.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in-view");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.05, rootMargin: "0px 0px -8% 0px" }
        );
        els.forEach((el) => io.observe(el));

        // Safety net: after 4s, force any remaining elements visible
        const safety = setTimeout(() => {
            document.querySelectorAll(".reveal:not(.in-view)").forEach((el) =>
                el.classList.add("in-view")
            );
        }, 4000);

        return () => {
            io.disconnect();
            clearTimeout(safety);
        };
    }, []);
}
